<template>
	<v-layout row wrap class="banner-simulator" id="banner-simulator">
		<v-flex xs12>
			<v-layout row wrap class="container banner-simulator-container">
				<v-flex xs12 md6>
					<v-layout row wrap>
						<v-flex xs12>
							<img
								src="/static/images-new/logos/logo-casamarket.svg"
								alt="logo casamarket"
								class="banner-simulator-logo"
							/>
						</v-flex>
						<v-flex v-if="catalog" class="title-logo-catalog w-bold newwarning--text mt-1">Inicia tu viaje hacia la transformación digital</v-flex>
						<v-flex xs12>
							<h2 v-if="catalog" class="banner-simulator-title newwarning--text">Crea Tu Tienda Online en 2 Pasos:</h2>
							<h2 class="newwarning--text w-black banner-simulator-title" v-else>
								¡REGISTRATE Y HAZ CRECER
								<span class="primary--text">TU NEGOCIO</span>!
							</h2>
						</v-flex>
						<v-flex xs12 mt-4>
							<v-flex v-if="catalog">
								<p class="newwarning--text w-medium banner-simulator-subtitle"
								v-for="(item, index) in listCreateStore" :key="index">
									<img src="/static/images-new/banners/check.svg" alt="icon-check">
									{{ item.name }}
								</p>
								<p class="banner-simulator-start-online">Listo! Empieza a vender online.</p>
							</v-flex>
							<p class="newwarning--text w-medium banner-simulator-subtitle" v-else>
								Sé parte de nuestro centro comercial virtual.
							</p>
						</v-flex>
						<v-flex xs12 v-if="!catalog">
							<p class="w-medium newinfo--text banner-simulator-description">
								Únete a nuestra comunidad: Junto a otros comercios locales
								vende en nuestra plataforma a clientes cercanos.
							</p>
						</v-flex>
						<v-flex xs12 class="column-hidden" v-if="!catalog">
							<v-btn
								class="banner-simulator-btn ma-0"
								color="primary"
								depressed
								@click="showMobileForm"
							>
								Quiero Vender
							</v-btn>
						</v-flex>
						<v-flex xs12>
							<v-flex
							xs8
							v-if="catalog"
							class="ma-0 btn-auto btn-catalog w-medium newwarning--text"
							depressed
							outline>
								Además obtén tu código de <span class="w-black warning--text">50% de descuento</span> en todos nuestro planes <a href="#catalog-plans" class="text-orange w-black href-depressed">AQUÍ</a>
							</v-flex>
						<a href="#como-funciona" class="href-depressed" v-else>
								<v-btn
									class="banner-simulator-btn ma-0"
									color="newprimary"
									depressed
									flat
									outline
								>
									Así Funciona
								</v-btn>
							</a>
						</v-flex>
						<v-flex xs12 class="column-hidden mt-4" v-if="catalog">
							<v-btn
								class="banner-catalog-simulator-btn ma-0"
								color="transparent"
								depressed
								@click="showMobileForm"
							>
								Quiero mi catálogo
							</v-btn>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12 md6 text-xs-center>
					<div class="banner-simulator-form" :class="{ 'show-form' : showForm }">
						<img
							src="/static/images-new/sections/phone-case.png"
							alt="simulador casa market"
							class="banner-simulator-image"
						/>
						<template v-if="stepIs(1)">
							<form-step-one
								@on-click="nextStep"
							></form-step-one>
						</template>
						<template v-else-if="stepIs(2)">
							<form-step-two
								:code-phone="codePhone"
								:document-selected="documentTypeSelected"
								:document-types="documentTypes"
								:email-validation="$v.$invalid"
								:form="form"
								:items="items"
								:validated="validated"
								:phone-invalid="phoneInvalid"
								:phone-message="phoneMessage"
								:document-validation="documentValidation"
								:validation-message="validationMessage"
								:list-plans="isListPlan"
								@close-form="closeForm"
								@get-data="setData"
								@valid-phone="validPhone"
							></form-step-two>
						</template>
						<template v-else-if="stepIs(3)">
							<form-step-three
								:center="location"
								:country-code="countryCode"
								:exact-location="exactLocation"
								:form="form"
								:height="height"
								:height-static="heightStatic"
								:latitude="latitude"
								:loading-location="loadingLocation"
								:location-inactive="locationInactive"
								:loading-register="loadingRegister"
								:longitude="longitude"
								:markers="markers"
								:zoom="zoom"
								:items="items"
								:message-bd="messageBD"
								@active-location="activeLocation"
								@back-step="backStep"
								@erase-location="eraseLocation"
								@get-address="setAddress"
								@get-data="setData"
								@on-center-changed="markerPosition"
								@selection-option="selectOption"
							></form-step-three>
						</template>
						<template v-else-if="stepIs(4)">
							<form-step-four
								:show-form="showForm"
								@close-form="closeForm"
							></form-step-four>
						</template>
						<template v-if="showStep">
							<v-btn
								class="banner-simulator-form-btn ma-0"
								:color="isQinti ? 'blue darken-4' : isLucky ? 'succesL' : 'newprimary'"
								:disabled="disabled"
								@click="nextStep"
							>
								{{ formBtnText }}
							</v-btn>
						</template>
					</div>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
	import { email } from 'vuelidate/lib/validators';
	import formStepFour from '@/components/simulator/form-step-four';
	import formStepOne from '@/components/simulator/form-step-one';
	import formStepThree from '@/components/simulator/form-step-three';
	import formStepTwo from '@/components/simulator/form-step-two';
	import helper from '@/shared/helper';

	const { debounce } = helper;

	function activeLocation() {
		this.loadingLocation = true;
		window.navigator.geolocation.getCurrentPosition((location) => {
			this.location = { lat: location.coords.latitude, lng: location.coords.longitude };
		});
	}

	function backStep() {
		if (!this.locationInactive) {
			this.locationInactive = true;
		} else {
			this.step -= 1;
			this.formBtnText = 'Siguiente';
		}
	}

	function closeForm() {
		this.step = 1;
		this.formBtnText = 'Siguiente';
		this.form = {
			address: '',
			commerceName: '',
			documentNumber: '',
			email: '',
			flagReplyAllProducts: true,
			flagTypePerson: 1,
			itemId: 0,
			latitude: 0,
			longitude: 0,
			name: '',
			password: '',
			phone: '',
			promotionCode: '',
			surName: '',
		};
		this.center = { lat: 0, lng: 0 };
		this.exactLocation = '';
		this.location = {};
		this.locationInactive = true;
		this.markers = [
			{
				position: {
					lat: 0,
					lng: 0,
				},
				icon: '/static/images-new/icons/icon-location-marker.png',
			},
		];
		this.validated = false;
		this.showForm = false;
		this.height = '406';
		const bodyTag = document.getElementById('body');
		const appTag = document.getElementById('app');
		bodyTag.style = '';
		appTag.style = '';
	}

	function countryCode(value) {
		if (value) {
			this.codePhone = value === 'PE' ? '+51' : '+593';
			this.loadResources();
		}
	}

	function disabled() {
		const keys = Object.keys(this.form);
		if (this.step === 2) {
			return keys.some(k =>
				k !== 'address' && k !== 'commerceName' && k !== 'latitude' &&
				k !== 'flagReplyAllProducts' && k !== 'longitude' && k !== 'promotionCode' &&
				k !== 'typePlan' && !this.form[k]) || this.loading || this.phoneInvalid ||
				this.documentValidation || this.$v.$invalid;
		}
		if (this.step === 3) {
			return keys.some(k => (k === 'address' || k === 'commerceName') &&
				k !== 'flagReplyAllProducts' && !this.form[k]) || this.loading;
		}
		return true;
	}

	function documentValidations({ configuration }, value) {
		const { maxLength, minLength } = configuration.validations;
		if (value) {
			if ((maxLength === minLength) && (value.length > maxLength || value.length < minLength)) {
				this.validationMessage = `Ingresar ${minLength} dígitos`;
				this.documentValidation = true;
			} else if (value.length < minLength) {
				this.validationMessage = `Mínimo ${minLength} dígitos`;
				this.documentValidation = true;
			} else if (value.length > maxLength) {
				this.validationMessage = `Máximo ${maxLength} dígitos`;
				this.documentValidation = true;
			} else {
				this.validationMessage = 'Campo requerido';
				this.documentValidation = false;
			}
		} else if (maxLength === minLength) {
			this.validationMessage = `Ingresar ${minLength} dígitos`;
			this.documentValidation = true;
		} else if (minLength === 0) {
			this.validationMessage = 'Campo requerido';
			this.documentValidation = false;
		} else if (minLength > 0) {
			this.validationMessage = `Mínimo ${minLength} dígitos`;
			this.documentValidation = true;
		} else {
			this.validationMessage = 'Campo requerido';
			this.documentValidation = false;
		}
	}

	function locationInactive(value) {
		const body = document.getElementById('body');
		body.className = value ? '' : 'body-pac';
	}

	async function loadResources() {
		const isPeru = this.countryCode === 'PE';
		let token = isPeru ? process.env.TOKEN_PERU : process.env.TOKEN_ECUADOR;
		if (this.isQinti) {
			token = process.env.TOKEN_QINTI;
		} else if (this.isLucky) {
			token = process.env.TOKEN_LUCKY;
		}
		const params = {
			countryCode: isPeru ? 'PER' : 'ECU',
		};
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		const requests = [
			this.$http.get('types-documents', { params }),
			this.$http.get('items/public?notShowEcommerces=true', { headers }),
		];
		[{ data: this.documentTypes }, { data: this.items }] = await Promise.all(requests);
		this.items = this.items.length > 0 ? [...this.items] : [{ id: 1, name: 'Bodega' }];
		this.documentTypeSelected = isPeru ? this.documentTypes.find(dt => dt.code === 'dni') :
			this.documentTypes.find(dt => dt.code === 'cedula');
		this.form.flagTypePerson = this.documentTypeSelected.id;
		this.codePhone = isPeru ? '+51' : '+593';
		this.documentValidations(this.documentTypeSelected);
	}

	function markerPosition(value) {
		const { latLng } = value;
		this.location.lat = latLng ? latLng.lat() : value.lat();
		this.location.lng = latLng ? latLng.lng() : value.lng();
		this.form.latitude = this.location.lat;
		this.form.longitude = this.location.lng;
	}

	function nextStep() {
		if (this.step < 3) {
			this.step += 1;
		}
		if (this.formBtnText === 'Registrarme' && this.isLucky) {
			this.register();
		} else if (this.formBtnText === 'Registrarme') {
			this.messageBD = true;
		} else if (this.step === 3) {
			this.formBtnText = 'Registrarme';
		}
	}

	async function register() {
		this.messageBD = false;
		this.loading = true;
		this.loadingRegister = true;
		const isPeru = this.countryCode === 'PE';
		let token = isPeru ? process.env.TOKEN_PERU : process.env.TOKEN_ECUADOR;
		if (this.isQinti) {
			token = process.env.TOKEN_QINTI;
		} else if (this.isLucky) {
			token = process.env.TOKEN_LUCKY;
		}
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		const newForm = { ...this.form };
		if (!isPeru && this.form.phone.length > 9) {
			if (Number(this.form.phone[0]) === 0) {
				const phoneStr = this.form.phone.toString();
				this.form.phone = phoneStr.slice(1, 10);
			}
		}
		newForm.phone = `${this.codePhone}${this.form.phone}`;
		const wsTemplate = isPeru ? process.env.TEMPLATE_CODE_PE : process.env.TEMPLATE_CODE;
		let body = {
			...newForm,
			flagNotifications: true,
			dataNotifications: {
				codeNotificationClient: isPeru ? process.env.TEMPLATE_SUCCESS_PE :
					process.env.TEMPLATE_SUCCESS,
				codeNotificationCompany: isPeru ? process.env.TEMPLATE_CONFIGURACTION_PE :
					process.env.TEMPLATE_CONFIGURACTION,
				companyId: isPeru ? process.env.COMPANY_ID_APP :
					process.env.COMPANY_ID_FORM,
				emailCompany: isPeru ? process.env.FORM_TO_APP_PE : process.env.FORM_TO_APP,
				from: isPeru ? process.env.FORM_FROM_APP_PE : process.env.FORM_FROM_APP,
				sheetId: isPeru ? process.env.SHEET_ID_PE :
					process.env.SHEET_ID,
				phoneCompany: isPeru ? process.env.WHATSAPP_NUMBER_PE :
					process.env.WHATSAPP_NUMBER,
				wtsTemplateCompany: isPeru ? process.env.TEMPLATE_WSP_PE :
					process.env.TEMPLATE_WSP,
				wtsTemplateClient: this.catalog ? process.env.TEMPLATE_WSP_CATALOG : wsTemplate,
				domain: 'http://bootventas.casamarket.la/rCust.php',
			},
			flowCreation: this.$route.hash === '#formulario' ? 'LANDING' : 'SIMULATOR',
			interested: this.$route.hash === '#formulario' ? this.form.typePlan : '',
		};
		if (isPeru) {
			delete body.dataNotifications.codeNotificationClient;
		}
		if (this.isQinti || this.isLucky) {
			body = {
				...newForm,
				flagNotifications: true,
				dataNotifications: {
					codeNotificationClient: this.isQinti ?
						process.env.TEMPLATE_SUCCESS_QINTI : process.env.TEMPLATE_SUCCESS_LUCKY,
					codeNotificationCompany: this.isQinti
						? process.env.TEMPLATE_CONFIGURACTION_QINTI : process.env.TEMPLATE_CONFIGURACTION_LUCKY,
					companyId: this.isQinti ?
						process.env.COMPANY_ID_APP_QINTI : process.env.COMPANY_ID_APP_LUCKY,
					emailCompany: this.isQinti ? process.env.FORM_TO_APP_QINTI : process.env.FORM_TO_APP_LUCKY,
					from: this.isQinti ? process.env.FORM_FROM_APP_QINTI : process.env.FORM_FROM_APP_LUCKY,
					sheetId: this.isQinti ? process.env.SHEET_ID_QINTI : process.env.SHEET_ID_LUCKY,
				},
				flowCreation: this.$route.hash === '#formulario' ? 'LANDING' : 'SIMULATOR',
				interested: this.$route.hash === '#formulario' ? this.form.typePlan : '',
			};
		}
		delete body.typePlan;
		try {
			await this.$http.post('com-ecommerce-companies/public', body, { headers });
			this.step += 1;
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				if (err.data.message === 'ACL_REGISTER_USER_ERROR') {
					this.showGenericError('El correo ya se encuentra registrado en el sistema.');
				}
			}
		} finally {
			this.loading = false;
			this.loadingRegister = false;
		}
	}

	function setAddress() {
		const input = document.getElementById('input-autocomplete');
		const autocomplete = new window.google.maps.places.Autocomplete(
			input,
			{
				types: ['geocode'],
			},
		);
		autocomplete.addListener('place_changed', () => {
			const place = autocomplete.getPlace();
			this.location = {
				lat: place.geometry.location.lat(),
				lng: place.geometry.location.lng(),
			};
			this.markers[0].position.lat = this.location.lat;
			this.markers[0].position.lng = this.location.lng;
			this.form.latitude = this.location.lat;
			this.form.longitude = this.location.lng;
		});
		this.form.address = '';
	}

	function setData({ model, value }) {
		const typePersonModel = model === 'flagTypePerson';
		const documentNumberModel = model === 'documentNumber';
		this.form[model] = typePersonModel ? value.id : value;
		if (typePersonModel) {
			this.documentTypeSelected = { ...value };
		}
		if ((typePersonModel || documentNumberModel) && this.form.documentNumber) {
			this.documentValidations(this.documentTypeSelected, this.form.documentNumber);
		}
	}

	function setLocation() {
		const latLng = { lat: parseFloat(this.location.lat), lng: parseFloat(this.location.lng) };
		const geocoder = new window.google.maps.Geocoder();
		if (this.locationInactive) {
			this.markers[0].position.lat = this.location.lat;
			this.markers[0].position.lng = this.location.lng;
			this.form.latitude = this.markers[0].position.lat;
			this.form.longitude = this.markers[0].position.lng;
		}
		geocoder.geocode({ location: latLng }, (results, status) => {
			if (status === 'OK') {
				if (results[0]) {
					this.exactLocation = results[0].formatted_address;
					this.zoom = 17;
				}
			}
		});
		this.locationInactive = false;
		this.loadingLocation = false;
	}

	function showMobileForm() {
		this.step = 2;
		this.showForm = true;
		this.height = '338';
		this.heightStatic = '358';
		const bodyTag = document.getElementById('body');
		const appTag = document.getElementById('app');
		bodyTag.style = 'overflow: hidden; height: 100vh';
		appTag.style = 'overflow: hidden; height: 100vh';
	}

	function showStep() {
		return this.step > 1 && this.step < 4;
	}

	function stepIs(stepNumber) {
		return this.step === stepNumber;
	}

	function validPhone() {
		this.validated = true;
	}

	function watchLocation(value) {
		if (value.lat && value.lng) {
			this.setLocation();
		} else {
			this.loadingLocation = false;
		}
	}

	function phoneInvalid() {
		if (this.form.phone) {
			const parsed = this.form.phone.split(' ').join('');
			if (parsed.length < 9) {
				this.phoneMessage = 'Ingresar al menos 9 dígitos';
			} else if (parsed.length > 10) {
				this.phoneMessage = 'Máximo 10 dígitos';
			}
			return parsed.length < 9 || parsed.length > 10;
		}
		return true;
	}

	function eraseLocation() {
		this.form.address = '';
		this.exactLocation = '';
		this.locationInactive = true;
	}

	function isListPlan() {
		return this.countryCode === 'PE' ? this.listPlansPer : this.listPlanEcu;
	}

	function created() {
		const isForm = this.$route.hash === '#formulario';
		if (isForm) {
			this.showMobileForm();
		}
		if (this.countryCode !== '') {
			this.loadResources();
		}
	}

	function validations() {
		return {
			form: {
				email: { email },
			},
		};
	}

	function isQinti() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'QINTI';
		}
		return false;
	}

	function selectOption(flag) {
		this.form.flagReplyAllProducts = flag === 'si';
		this.register();
	}

	function isLucky() {
		if (this.$route.query.project) {
			return this.$route.query.project === 'LUCKY';
		}
		return false;
	}

	function data() {
		return {
			center: { lat: 0, lng: 0 },
			codePhone: '+51',
			documentTypes: [],
			documentTypeSelected: {},
			documentValidation: true,
			exactLocation: '',
			form: {
				address: '',
				commerceName: '',
				documentNumber: '',
				email: '',
				flagReplyAllProducts: true,
				flagTypePerson: 1,
				itemId: 1,
				latitude: 0,
				longitude: 0,
				name: '',
				password: '',
				phone: '',
				promotionCode: '',
				surName: '',
				typePlan: this.$route.query.plan ? 'Plan Promocional' : '',
			},
			formBtnText: 'Siguiente',
			height: '444',
			heightStatic: '444',
			items: [],
			listCreateStore: [
				{
					id: 1,
					name: 'Registra tus datos y recibe tus accesos CTA.',
				},
				{
					id: 2,
					name: 'Agrega Productos a tu Catálogo, medios de pago y envío.',
				},
			],
			loading: false,
			location: {},
			locationInactive: true,
			markers: [
				{
					position: {
						lat: 0,
						lng: 0,
					},
					icon: '/static/images-new/icons/icon-location-marker.png',
				},
			],
			phoneMessage: 'Ingresar al menos 9 dígitos',
			showForm: false,
			step: 1,
			validated: false,
			validationMessage: 'Campo requerido',
			zoom: 14,
			listPlansPer: [
				{
					code: 'Plan Promocional',
					name: 'Plan Promocional - S/500.00',
				},
				{
					code: 'Plan Básico',
					name: 'Plan Básico - S/799.00',
				},
				{
					code: 'Plan Full',
					name: 'Plan Full - S/1,200.00',
				},
				{
					code: 'Plan Mega',
					name: 'Plan Mega - S/2,200.00',
				},
				{
					code: 'Plan Multicomercio',
					name: 'Plan Multicomercio - S/1,800.00',
				},
				{
					code: 'Plan Multicomercio Full',
					name: 'Plan Multicomercio Full - S/2,500.00',
				},
			],
			listPlanEcu: [
				{
					code: 'Plan Promocional',
					name: 'Plan Promocional - $150',
				},
			],
			loadingLocation: false,
			loadingRegister: false,
			messageBD: false,
		};
	}

	export default {
		name: 'banner-simulator',
		created,
		components: {
			formStepFour,
			formStepOne,
			formStepThree,
			formStepTwo,
		},
		computed: {
			disabled,
			phoneInvalid,
			showStep,
			isListPlan,
			isQinti,
			isLucky,
		},
		data,
		methods: {
			activeLocation,
			backStep,
			closeForm,
			documentValidations,
			eraseLocation,
			loadResources,
			markerPosition: debounce(markerPosition),
			nextStep,
			register,
			setAddress,
			setData,
			setLocation,
			showMobileForm,
			stepIs,
			validPhone,
			selectOption,
		},
		props: {
			countryCode: {
				type: String,
				default: '',
			},
			latitude: [String, Number],
			longitude: [String, Number],
			catalog: {
				default: false,
				type: Boolean,
			},
		},
		validations,
		watch: {
			countryCode,
			location: {
				deep: true,
				handler: watchLocation,
			},
			locationInactive,
		},
	};
</script>

<style lang="scss" scoped>
	.banner-simulator {
		background-image: url('/static/images-new/banners/simulator-banner-mobile.png');
		background-position: center -80px;
		background-repeat: no-repeat;
		background-size: 1000px;

		@media (min-width: 936px) {
			background-image: url('/static/images-new/banners/simulator-banner-desktop.png');
			background-position: center;
			background-size: cover;
		}

		&-container {
			padding-bottom: 20px;
			text-align: center;

			@media (min-width: 936px) {
				padding-top: 127px;
				padding-bottom: 62px;
				text-align: left;
			}
		}

		&-title {
			font-size: size(large21);
			line-height: 36px;
			margin-top: 72px;

			@media (min-width: 936px) {
				font-size: size(large26);
				font-weight: map-get($weight, black);
				margin-top: 55px;
			}

			span {
				font-size: size(large27);

				@media (min-width: 936px) {
					font-size: size(large32);
				}
			}
		}

		&-description {
			font-size: size(medium18);
			line-height: 22px;
			margin: 22px auto 26px;
			max-width: 291px;

			@media (min-width: 936px) {
				margin: 7px 0px 39px;
				max-width: 380px;
			}
		}

		&-form {
			display: none;
			margin: 0 auto;
			position: relative;
			width: fit-content;
			width: -moz-fit-content;

			@media (min-width: 936px) {
				display: block;
			}

			&.show-form {
				display: block;
				height: 100vh;
				position: absolute;
				top: 0;
				width: 100%;

				.banner-simulator-form-btn {
					border-bottom-left-radius: 0px;
					border-bottom-right-radius: 0px;
					bottom: 0px;
					left: 0px;
					width: 100%;
				}
			}
		}

		&-image {
			display: none;

			@media (min-width: 936px) {
				display: initial;
				height: 807px;
				position: relative;
				z-index: 1;
			}
		}

		&-btn {
			border-radius: 5px !important;
			font-size: size(medium18);
			font-weight: weight(black);
			height: 64px !important;
			width: 257px !important;

			@media (min-width: 936px) {
				width: 205px !important;
			}
		}

		&-form-btn {
			border-bottom-left-radius: 12px;
			border-bottom-right-radius: 12px;
			bottom: 54px;
			color: color(white) !important;
			font-size: size(large);
			font-weight: weight(black);
			height: 54px;
			left: 17px;
			position: absolute;
			width: 90.5%;
			z-index: 1;

			&.btn.btn--disabled:not(.btn-icon):not(.btn-flat) {
				color: color(white) !important;
				background-color: color(cardborder) !important;
				opacity: 1 !important;
			}
		}

		&-subtitle {
			font-size: size(large23);
			line-height: 1.45;
			margin: 23px auto 0px;
			max-width: 336px;
			text-align: left;

			@media (min-width: 936px) {
				margin: 3px 0px 0px;
				font-size: size(large);
				max-width: 425px;
			}
		}

		&-start-online {
			color: #02979b;
			font-size: map-get($sizes, large25);
			font-weight: map-get($weight, heavy);
			margin: 28px 0;
		}

		&-green {
			color: map-get($colors, subtitle-green);
			font-size: 30px;
			font-weight: 700;
		}

		&-logo {
			height: 53px;

			@media (min-width: 936px) {
				height: 63px;
			}
		}
	}

	.container {
		padding-left: 0px !important;
		padding-right: 0px !important;

		@media (min-width: 936px) {
			padding-left: 24px !important;
			padding-right: 24px !important;
		}
	}

	.column-hidden {
		@media (min-width: 936px) {
			display: none;
		}

		.banner-simulator-btn {
			margin-bottom: 22px !important;
		}

		.banner-catalog-simulator-btn {
			border: 1px solid map-get($colors, orange-cat) !important;
			border-radius: 5px;
			color: map-get($colors, orange-cat) !important;
			font-size: map-get($sizes, medium18) !important;
			font-weight: map-get($weight, black);
			height: 64px !important;
   		width: 257px !important;
		}
	}

	.wrapper-message {
		background: rgba(0, 0, 0, .6);
		bottom: 0;
		display: flex;
		flex-direction: column;
    justify-content: center;
		height: 100%;
		left: 0;
		position: absolute;
		top: 0;
		right: 0;
		width: 100%;
		z-index: 3;

		&-buttons {
			color: map-get($colors, white);
			width: 100%;
		}

		&-text {
			font-size: 22px;
    	font-weight: 700;
		}

		&-btn {
			background: map-get($colors, darkenprimary);
			border-radius: 4px;
			padding: 10px 0;
			width: 100%;
		}

		.btn-orange {
			background: map-get($colors, newprimary);
		}

		.btn-lucky {
			background: map-get($colors, back-l) !important;
		}

		.btn-lucky-no {
			background: map-get($colors, succes-l) !important;
		}
	}

	.title-logo-catalog {
		font-size: map-get($sizes, medium16);
	}

	.subtitle-catalog {
		font-size: map-get($sizes, large26);
		font-weight: map-get($weight, black);
	}

	.link-plans {
		background-color: map-get($colors, white);
		border-radius: 7px;
  	box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.1);
		max-width: 347px;
	}

	.btn-catalog {
		background-color: map-get($colors, white) !important;
		border-radius: 7px;
		border: 1px solid map-get($colors, white);
		box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.1) !important;
		line-height: normal;
		font-size: 21px;
		margin: 0 auto !important;
		text-align: left;
		text-transform: inherit !important;
		padding: 15px 20px 15px 30px !important;
		max-width: 310px !important;

		@media (min-width: 936px) {
			font-size: 23px;
			margin: 0 !important;
			max-width: 347px !important;
		}
	}

	.text-orange {
		color: #ff5c00;
	}
</style>


// WEBPACK FOOTER //
// src/components/simulator/banner-simulator.vue